import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexBasiccard',
  setup(__props) {

const basicFlat = defineAsyncComponent(() => import("@/components/theme/advance/basic/basicFlat.vue"))
const shadowCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/shadowCard.vue"))
const iconCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/iconCard.vue"))
const darkCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/darkCard.vue"))
const footerCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/footerCard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Image Cropper"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicFlat)),
        _createVNode(_unref(shadowCard)),
        _createVNode(_unref(iconCard)),
        _createVNode(_unref(darkCard)),
        _createVNode(_unref(footerCard))
      ])
    ])
  ], 64))
}
}

})